var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKeyboard = function SvgKeyboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.43 730.18V293.82c0-28.92 10.22-53.6 30.67-74.05 20.45-20.45 45.13-30.67 74.05-30.67h649.71c28.92 0 53.6 10.22 74.05 30.67 20.45 20.45 30.68 45.13 30.68 74.05v436.36c0 28.92-10.23 53.6-30.68 74.05-20.45 20.45-45.13 30.67-74.05 30.67h-649.7c-28.92 0-53.6-10.22-74.05-30.67-20.45-20.45-30.67-45.13-30.67-74.05Zm69.82 0c0 23.27 11.64 34.91 34.91 34.91h649.7c23.27 0 34.91-11.64 34.91-34.91V293.82c0-23.27-11.64-34.91-34.91-34.91h-649.7c-23.27 0-34.91 11.64-34.91 34.91v436.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.34 621.36h341.33a35.596 35.596 0 0 1 6.81.67c1.12.22 2.23.5 3.32.83 1.09.33 2.17.72 3.23 1.15 1.06.44 2.09.93 3.1 1.46 1.01.54 1.99 1.13 2.94 1.76.95.64 1.87 1.32 2.75 2.04.88.73 1.73 1.49 2.54 2.3.81.81 1.58 1.65 2.3 2.54.72.88 1.4 1.8 2.04 2.75.63.95 1.22 1.93 1.76 2.94s1.03 2.04 1.47 3.1a33.5 33.5 0 0 1 1.15 3.23c.33 1.09.61 2.2.83 3.32a35.596 35.596 0 0 1 .67 6.81 35.596 35.596 0 0 1-.67 6.81c-.22 1.12-.5 2.23-.83 3.32a37.6 37.6 0 0 1-1.15 3.23c-.44 1.06-.93 2.09-1.47 3.1-.54 1.01-1.12 1.99-1.76 2.94-.64.95-1.32 1.87-2.04 2.75-.73.88-1.49 1.73-2.3 2.54-.81.81-1.65 1.58-2.54 2.3-.88.73-1.8 1.41-2.75 2.04-.95.64-1.93 1.22-2.94 1.76s-2.04 1.03-3.1 1.46a33.5 33.5 0 0 1-3.23 1.15c-1.09.33-2.2.61-3.32.83a35.596 35.596 0 0 1-6.81.67H341.34a35.596 35.596 0 0 1-6.81-.67c-1.12-.22-2.23-.5-3.32-.83a37.6 37.6 0 0 1-3.23-1.15 38.12 38.12 0 0 1-3.1-1.46c-1.01-.54-1.99-1.13-2.94-1.76-.95-.64-1.87-1.32-2.75-2.04-.88-.73-1.73-1.49-2.54-2.3-.81-.81-1.58-1.65-2.3-2.54-.73-.88-1.41-1.8-2.04-2.75-.64-.95-1.22-1.93-1.76-2.94s-1.03-2.04-1.46-3.1a33.5 33.5 0 0 1-1.15-3.23c-.33-1.09-.61-2.2-.83-3.32a35.596 35.596 0 0 1-.67-6.81 35.596 35.596 0 0 1 .67-6.81c.22-1.12.5-2.23.83-3.32a37.6 37.6 0 0 1 1.15-3.23c.44-1.06.93-2.09 1.46-3.1.54-1.01 1.13-1.99 1.76-2.94.64-.95 1.32-1.87 2.04-2.75.73-.88 1.49-1.73 2.3-2.54.81-.81 1.65-1.58 2.54-2.3.88-.73 1.8-1.41 2.75-2.04.95-.64 1.93-1.22 2.94-1.76s2.04-1.03 3.1-1.46a33.5 33.5 0 0 1 3.23-1.15c1.09-.33 2.2-.61 3.32-.83a35.596 35.596 0 0 1 6.81-.67",
    style: {
      fillRule: "evenodd"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 320.01,
    cy: 378.67,
    r: 42.67
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.01,
    cy: 378.67,
    r: 42.67
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 576.01,
    cy: 378.67,
    r: 42.67
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 378.67,
    r: 42.67
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 320.01,
    cy: 506.67,
    r: 42.67
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.01,
    cy: 506.67,
    r: 42.67
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 576.01,
    cy: 506.67,
    r: 42.67
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 704.01,
    cy: 506.67,
    r: 42.67
  })));
};
export default SvgKeyboard;